import React from 'react';

import chargerPlugIcon from '../../../assets/chargerPlugIcon.png';


export const ChargerPlugIcon = (size) => {
    return (
        <img src={chargerPlugIcon} alt="thunder icon" className="chager_plug_icon" style={{ width: size + 'px' }} />
    );
};
